export default "__VITE_ASSET__BKnM_LGj__"